import React from "react";
import { ITag } from "../../../types/contacts";

interface ChatTagsProps {
  tags: ITag[];
  value: number | 0;
  onChange: (value: number | 0) => void;
}

export const ChatTags: React.FC<ChatTagsProps> = ({
  tags,
  value,
  onChange,
}) => {
  return (
    <>
      {/* CSS LOCAL DO COMPONENTE */}
      <style>
        {`
          .chat-tags {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;      // permite quebrar linha
            overflow-x: auto;
            padding-bottom: 4px;      
            
            max-height: 64px;     // limita a 2 linhas
            overflow: hidden;     // esconde o resto            
          }

          .chat-tagssss::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 10px;
            background: linear-gradient(to bottom, transparent, #fff);
          }          

          .chat-tags::-webkit-scrollbar {
            height: 6px;
          }

          .chat-tags::-webkit-scrollbar-thumb {
            background: #cfd1d4;
            border-radius: 4px;
          }

          .chat-tag {
            padding: 6px 14px;
            border-radius: 999px;
            background: #f0f2f5;
            color: #3b4a54;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            white-space: nowrap;
            user-select: none;
            transition: all 0.15s ease;
            /* 👇 BORDA FINA */
            border: 1px solid #d1d5db;              
          }

          .chat-tag:hover {
            background: #e4e6eb;
          }

          .chat-tag.active {
            background: #d9fdd3;
            color: #056162;
          }

          /* 👇 BORDA COM COR DO ATIVO */
          border-color: #25d366;          
        `}
      </style>

      <div className="chat-tags">

        {/* TAGS DINÂMICAS */}
        {tags.map((tag) => (
          <div
            key={tag.id}
            className={`chat-tag ${value === tag.id ? "active" : ""}`}
            onClick={() => onChange(tag.id)}
            title={tag.name}
          >
            {tag.name}
          </div>
        ))}
      </div>
    </>
  );
};
